module.exports = __webpack_public_path__ + "img/carbon-menu-forest.998a3166.svg";